"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6642],{

/***/ 6642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Joinus; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _reusable_ButtonArrow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6525);



function Joinus() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        id: "joinus",
        className: "flex flex-col md:flex-row items-center bg-[#051747]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-[100%] py-[70px] md:py-0 text-white md:w-[50%] pl-[5vw] md:pl-[100px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-4xl sm:text-6xl ",
                        children: "Careers"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "pt-8 text-xl sm:text-3xl font-light leading-relaxed",
                        children: [
                            "Are you inspired by doing great work? ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            " We're too. Join us."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reusable_ButtonArrow__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        txt: "Know more",
                        link: "/career",
                        style: "w-[170px] text-gray-200 [&>div]:border-gray-400 "
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: "/career/careers.webp",
                    className: "w-[100vw] md:w-auto md:h-[100vh] md:min-h-[104vh] mx-auto object-cover",
                    width: "500",
                    height: "500",
                    alt: "how-digitisation-helps-formulation-companies",
                    sizes: "(max-width: 500px) 50vw, (max-width: 1200px) 70vw, 100vw",
                    placeholder: "blur",
                    blurDataURL: "/career/careers.webp"
                })
            })
        ]
    });
}; // import Image from "next/future/image";
 // import ButtonArrow from "../reusable/ButtonArrow";
 // export default function Joinus() {
 //   return (
 //     <section id="joinus" className="flex flex-col-reverse md:flex-row items-center">
 //       <section >
 //         <Image
 //           src="/contactushome/pexels-alejandro.webp"
 //           className="w-[100vw] md:w-auto md:h-[100vh] md:min-h-[104vh] mx-auto object-cover"
 //           width="500"
 //           height="500"
 //           alt={"how-digitisation-helps-formulation-companies"}
 //           sizes="(max-width: 500px) 50vw,
 //             (max-width: 1200px) 70vw, 100vw"
 //           placeholder="blur"
 //           blurDataURL="/contactushome/pexels-alejandro.webp"
 //         />
 //       </section>
 //       <div className="w-[100%] py-[70px] md:py-0 text-white md:w-[50%] pl-[5vw] md:pl-[100px">
 //         <h1 className="text-4xl  sm:text-6xl text-black">Are you inspired by doing great work? <br/>  <small className="text-2xl sm:text-4xl text-gray-500">We're too.</small> </h1>
 //         {/* <p className="pt-8 text-xl sm:text-3xl font-light leading-relaxed text-black">
 //         </p> */}
 //         <ButtonArrow txt="Join us" link="/career" style="w-[170px] text-black bg-[#f1aa4e] [&>div]:border-gray-400 text-center" />
 //       </div>
 //     </section>
 //   );
 // }


/***/ }),

/***/ 6525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4998);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8388);





// const ButtonArrow = ({ link, txt, style }) => {
//   return (
//     <div className={twMerge(`relative text-slate-900 `, style)}>
//       <Link href={link}>
//         <div className="flex gap-0 hover:gap-2 ml-2 hover:tracking-wider duration-200 transition-all whitespace-nowrap tracking-wide text-xl xs:text-2xl pb-1 mt-7 font-medium  border-b-2 border-gray-500 cursor-pointer">
//           {txt}
//           <span aria-hidden="true" className="ml-2">
//             &rarr;
//           </span>
//         </div>
//       </Link>
//     </div>
//   );
// };
// export default ButtonArrow;
var ButtonArrow = function(param) {
    var link = param.link, txt = param.txt, style = param.style, btnStyle = param.btnStyle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_3__/* .twMerge */ .m6)("relative text-slate-900", style),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: link,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_3__/* .twMerge */ .m6)("flex text-xl tracking-wide items-center mt-2 font-medium cursor-pointer hover:translate-x-1 hover:text-[#f1aa4e] duration-200 transition-all w-fit", btnStyle),
                children: [
                    txt,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-hidden": "true",
                        className: "text-[#f1aa4e] sm:text-inherit",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonArrow);


/***/ })

}]);